// extracted by mini-css-extract-plugin
export default {"wraper":"Input_wraper__MRLvJ","input":"Input_input__i+eKT","iconRight":"Input_iconRight__Z+iEF"};